<script>
  import { assets, base } from '$app/paths';
  import {
    BodyText,
    DatawrapperChart,
    GraphicBlock,
    FeaturePhoto,
    Video,
    PhotoPack,
    BlogPost,
  } from '@reuters-graphics/graphics-components';

  // Import coalition data from Google sheet
  import coalitionData from '$lib/data/coalition-data.json';

  // Import custom components for specific block types
  import Mines from './components/Mines.svelte';
  import Columns from './components/Columns/index.svelte';
  import TrafficVideo from './components/TrafficVideo/index.svelte';
  import Table from '$lib/components/Table/index.svelte';
  import TableLegend from '$lib/components/TableLegend/index.svelte';
  import Post14VideoIntro from './components/post14/VideoIntro/VideoIntro.svelte';
  import PhotoPack16 from './components/post16/PhotoPack.svelte';
  import ProtestMap from './components/ProtestsMap/index.svelte';
  import Post18ShipList from './components/post18/ShipList.svelte';
  import Post18PhotoPack from './components/post18/PhotoPack.svelte';
  import TankersVideo from './components/TankersVideo/index.svelte';
  import OilInfraMap from './components/OilInfraMap/index.svelte';

  // Import ai2svelte components...
  import AiMap from './ai2svelte/ai-chart.svelte';
  import Iranattacks from './ai2svelte/iranattacks.svelte';
  import PowerStructure from './ai2svelte/power-structure.svelte';
  import SecurityChain from './ai2svelte/security-chain.svelte';
  import Post3hormuz from './ai2svelte/post3hormuz.svelte';
  import Post3OilPrice from './ai2svelte/post-3-oilprice.svelte';
  import Post3HormuzOilFlow from './ai2svelte/post-3-hormuzoilflow.svelte';
  import Post2SecurityChain from './ai2svelte/Post-2_security-chain.svelte';
  import Post2PowerStructure from './ai2svelte/Post-2_power-structure.svelte';
  import Post2LeadershipHouse from './ai2svelte/Post-2_leadership-house.svelte';
  import Post5CancelledFlights from './ai2svelte/post-5-cancelled-flights.svelte';
  import Post4Approval from './ai2svelte/Post-4_approval.svelte';
  import Post4Military from './ai2svelte/Post-4_approval_militaryforce.svelte';
  import Post5UpdateFlightsRoutes from './ai2svelte/post-5_update-flightsroutes.svelte';
  import Post12IranAttackedCountries from './ai2svelte/post12-iran-attacked-countries.svelte';
  import Post8BeforeAfterImg from './ai2svelte/post-8_before-after.svelte';
  import Post8NatanzDamage from './ai2svelte/post-8_natanz-damage.svelte';
  import Post8IranNuclear from './ai2svelte/post-8_iran-nuclear-sites.svelte';
  import Post8NatanzUnderground from './ai2svelte/post-8_natanz-underground.svelte';
  import { truthy } from '$utils/propValidators';
  import Post13Beirut from './ai2svelte/post-13_beirut.svelte';
  import Post11Kurdistan from './ai2svelte/post-11_kurdistan.svelte';
  import Post13Lebanon from './ai2svelte/post-13_lebanon.svelte';
  import Post14Teheranoil from './ai2svelte/post14-teheranoil.svelte';
  import Post14Refinery from './ai2svelte/post14-refinery.svelte';
  import Post14Body from './ai2svelte/post14-body.svelte';
  import Post15ArmsImportsRegion from './ai2svelte/post-15-arms-imports-region.svelte';
  import Post15ArmsImportsMideast from './ai2svelte/post-15-arms-imports-mideast.svelte';
  import Post18Vesselmap from './ai2svelte/post18-vesselmap.svelte';
  import Post18Attacks from './ai2svelte/post18-attacks.svelte';
  import Post19Pipelines from './ai2svelte/post19-pipelines.svelte';
  import Post19Khargisland from './ai2svelte/post19-khargisland.svelte';
  import Post19Terminals from './ai2svelte/post19-terminals.svelte';
  import Post19Vessels from './ai2svelte/post19-vessels.svelte';
  import Post21PowerStructure from './ai2svelte/Post-21_power-structure.svelte';
  import Post20StratotankerDiagram from './ai2svelte/post20-stratotanker-diagram.svelte';
  import Post20IsraelStratotankers from './ai2svelte/post20-israel-stratotankers.svelte';
  import Post20StratotankerMission01 from './ai2svelte/post20-stratotanker-mission-01.svelte';
  import Post20StratotankerMission02 from './ai2svelte/post20-stratotanker-mission-02.svelte';
  import Post20StratotankerMission03 from './ai2svelte/post20-stratotanker-mission-03.svelte';
  import Post20StratotankerMission04 from './ai2svelte/post20-stratotanker-mission-04.svelte';

  // ...and add them to this object.
  const aiCharts = {
    AiMap,
    Iranattacks,
    PowerStructure,
    SecurityChain,
    Post3hormuz,
    Post3OilPrice,
    Post3HormuzOilFlow,
    Post8BeforeAfterImg,
    Post8NatanzDamage,
    Post8IranNuclear,
    Post8NatanzUnderground,
    Post2LeadershipHouse,
    Post2PowerStructure,
    Post2SecurityChain,
    Post5CancelledFlights,
    Post5UpdateFlightsRoutes,
    Post4Approval,
    Post4Military,
    Post11Kurdistan,
    Post12IranAttackedCountries,
    Post13Beirut,
    Post13Lebanon,
    Post14Teheranoil,
    Post14Refinery,
    Post14Body,
    Post15ArmsImportsRegion,
    Post15ArmsImportsMideast,
    Post18Vesselmap,
    Post18Attacks,
    Post19Pipelines,
    Post19Khargisland,
    Post19Vessels,
    Post19Terminals,
    Post21PowerStructure,
    Post20StratotankerDiagram,
    Post20IsraelStratotankers,
    Post20StratotankerMission01,
    Post20StratotankerMission02,
    Post20StratotankerMission03,
    Post20StratotankerMission04,
  };

  let { content, isLastPost = false } = $props();

  let firstTableIndex = $derived(
    content.blocks.findIndex((block) => block.type === 'table')
  );
</script>

<BlogPost
  title={content.title}
  slugTitle={content.slugTitle}
  authors={content.authors}
  publishTime={content.publishedDate}
  updateTime={content.updatedDate}
  {base}
  {isLastPost}
>
  {#each content.blocks as block, index}
    {#if block.type === 'text'}
      <BodyText class="!fmt-4" text={block.text} />
    {:else if block.type === 'table'}
      <GraphicBlock
        id={block.id}
        class="fmy-6"
        width="wide"
        textWidth="wide"
        title={block.title}
        ariaDescription={block.altText}
      >
        <Table
          data={coalitionData.clean}
          id={block.id}
          backgroundField={block.backgroundField}
          pattern={block.pattern}
        />
        {#if index === firstTableIndex}
          <TableLegend
            legendBg={block.legendBg}
            legendPattern={block.legendPattern}
          />
        {/if}
      </GraphicBlock>
    {:else if block.type === 'datawrapper'}
      <DatawrapperChart
        id={block.id}
        src={block.src}
        ariaLabel={block.ariaLabel}
      />
    {:else if block.type === 'photo'}
      <FeaturePhoto
        src={`${assets}/${block.src}`}
        altText={block.altText}
        caption={block.caption}
        lazy={true}
        width={block.width}
      />
    {:else if block.type === 'photo-pack'}
      <PhotoPack
        id={block.id}
        class={block.class}
        width={block.width}
        textWidth={block.textWidth}
        gap={Number(block.gap)}
        images={block.images.map((img) => ({
          ...img,
          src: `${assets}/${img.src}`,
        }))}
      />
    {:else if block.type === 'photo-pack-16'}
      <PhotoPack16 {block} />
    {:else if block.type === 'photo-pack-18'}
      <Post18PhotoPack {block} />
    {:else if block.type === 'ai-graphic'}
      {#if !aiCharts[block.chart]}
        {(console.warn(`Unable to find "${block.chart}" in aiCharts.`), '')}
      {:else}
        <GraphicBlock
          id={block.chart}
          snap={block.snap === 'true' ? true : false}
          class={block.class}
          width={block.width}
          textWidth={block.textWidth}
          title={block.title}
          description={block.description}
          notes={block.notes}
          ariaDescription={block.altText}
        >
          {@const AiGraphic = aiCharts[block.chart]}
          <AiGraphic assetsPath={assets || '/'} />
        </GraphicBlock>
      {/if}
    {:else if block.type === 'video'}
      <Video
        src="{assets}/{block.src}"
        ariaDescription={block.ariaDescription}
        notes={block.notes}
        width={block.width}
        class={block.class}
        loopVideo={truthy(block.loopVideo)}
        controlsPosition={block.controlsPosition}
      />
    {:else if block.type === 'mines'}
      <Mines {block} />
    {:else if block.type === 'ProtestMap'}
      <ProtestMap
        width={block.width}
        notes={block.notes}
        altText={block.altText}
        view={block.view}
      />
    {:else if block.type === 'post18-ship-list'}
      <Post18ShipList {block} />

      <!-- Column grid set up -->
    {:else if block.type === 'columns'}
      <Columns
        numColumns={Number(block.numColumns ?? block.items?.length)}
        breakpoint={Number(block.breakpoint)}
        width={block.width}
        gap={block.gap}
        class={block.class}
      >
        {#each block.items as childBlock}
          {#if childBlock.type === 'photo'}
            <FeaturePhoto
              src={`${assets}/${childBlock.src}`}
              altText={childBlock.altText}
              caption={childBlock.caption}
              lazy={true}
              width={childBlock.width}
            />
          {:else if childBlock.type === 'ai-graphic'}
            {#if !aiCharts[childBlock.chart]}
              {''}
            {:else}
              <GraphicBlock
                id={childBlock.chart}
                snap={childBlock.snap === 'true' ? true : false}
                class={childBlock.class}
                width={childBlock.width}
                textWidth={childBlock.textWidth}
                title={childBlock.title}
                description={childBlock.description}
                notes={childBlock.notes}
                ariaDescription={childBlock.altText}
              >
                {@const AiGraphic = aiCharts[childBlock.chart]}
                <AiGraphic assetsPath={assets || '/'} />
              </GraphicBlock>
            {/if}
          {:else if childBlock.type === 'video'}
            <Video
              src="{assets}/{childBlock.src}"
              ariaDescription={childBlock.aria}
              notes={childBlock.notes}
              width={childBlock.width}
            />
          {:else if childBlock.type === 'mines'}
            <Mines block={childBlock} />
          {:else if childBlock.type === 'column-item'}
            <div class="column-item">
              {#if childBlock.title}
                <p class="column-item__title">{childBlock.title}</p>
              {/if}
              {#if childBlock.chatter}
                <p class="column-item__chatter">{childBlock.chatter}</p>
              {/if}
              {#each childBlock.items as innerBlock}
                {#if innerBlock.type === 'photo'}
                  <FeaturePhoto
                    src={`${assets}/${innerBlock.src}`}
                    altText={innerBlock.altText}
                    caption={innerBlock.caption}
                    lazy={true}
                    width={innerBlock.width}
                  />
                {/if}
              {/each}
            </div>
          {:else}
            {''}
          {/if}
        {/each}
      </Columns>
    {:else if block.type === 'traffic-video'}
      <TrafficVideo note={block.note} source={block.source} />
    {:else if block.type === 'Datawrapper'}
      <DatawrapperChart
        title={block.title}
        ariaLabel={block.ariaLabel}
        id={block.id}
        src={block.src}
      />
    {:else if block.type === 'post14-video-intro'}
      <Post14VideoIntro notes={block.caption} />
    {:else if block.type === 'tankers-timeline'}
      <TankersVideo
        title={block.title}
        description={block.description}
        notes={block.notes}
      />
    {:else if block.type === 'oil-infra-map'}
      <OilInfraMap />
    {:else}
      {(console.warn(`Unknown block type: "${block.type}"`), '')}
    {/if}
  {/each}
</BlogPost>

<style lang="scss">
  .column-item__title {
    font-family: var(--theme-font-family-subhed);
    font-size: var(--theme-font-size-base);
    font-weight: 600;
    line-height: 1.1;
    color: var(--theme-colour-text-primary);
    margin: 0 0 0.25em;
  }
  .column-item__chatter {
    font-family: var(--theme-font-family-note);
    font-size: calc(0.9 * var(--theme-font-size-base));
    font-weight: 300;
    line-height: 1.3;
    color: var(--theme-colour-text-primary);
    margin: 0 0 0.5em;
  }
</style>
